import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";
import { CrmOrganizationToAddressBookContactRecordLinkContainerModel } from "../../../../../../models/aggregates/crm/organization-to-address-book-contact-record";
@Injectable({
	providedIn: "root",
})
export class CrmOrganizationToAddressBookContactRecordLinkService extends BaseApiTemplateService<CrmOrganizationToAddressBookContactRecordLinkContainerModel> {
	readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + "organization-to-address-book-contact-record-links/backoffice-ep";

	constructor(http: HttpClient) {
		super();
		this.apiUrl = this.url;
		this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.CRM_PREFIX + "organization-to-address-book-contact-record-links/backoffice-ep";
		this.httpClient = http;
	}
}
